var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusReady(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#023E09"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54707 12.7102L4.47158 9.43071C4.28682 9.23369 4.28682 8.91424 4.47158 8.71719L5.14071 8.00367C5.32547 7.80663 5.62507 7.80663 5.80984 8.00367L7.88164 10.2129L12.3192 5.48102C12.504 5.284 12.8036 5.284 12.9883 5.48102L13.6574 6.19454C13.8422 6.39156 13.8422 6.71101 13.6574 6.90805L8.21621 12.7102C8.03142 12.9072 7.73184 12.9072 7.54707 12.7102Z",
    fill: "#ABDE19"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusReady);
export default __webpack_public_path__ + "static/media/status-ready.333e4d29.svg";
export { ForwardRef as ReactComponent };